import React, {Component} from 'react'
import {BrowserRouter as Router, Route, Switch, Redirect} from 'react-router-dom';
import Olympic from './components/olympic';
import Area from './components/area';
import store from 'store';
import {AREA_ID_OF_TOKYO} from './components/configure/configure';
import queryString from 'query-string'

class App extends Component {
    render() {
        const getAreaId = () => {
            const area = store.get('area');
            return area ? area.id : AREA_ID_OF_TOKYO;
        }
        const params = queryString.parse(window.location.search);
        return (
            <Router>
                <div className="App">
                    <Switch>
                        <Route exact path='/' component={Area}/>
                        <Route path='/schedule/:areaId' component={Olympic}/>
                        <Redirect from="/schedule"
                                  to={params.from ? "/schedule/" + getAreaId() + "?from=" + params.from : "/schedule/" + getAreaId()}/>
                    </Switch>
                </div>
            </Router>
        );
    }
}

export default App


// WEBPACK FOOTER //
// ./src/App.js